<div class="unassigned-drivers-container">
  <h4>Unassigned Drivers</h4>
  <p class="text-muted">View drivers that are currently not assigned to any loads.</p>

  <!-- Placeholder for unassigned drivers content -->
  <div class="placeholder-content">
    <i class="fa fa-user-times fa-3x text-muted"></i>
    <p>Unassigned drivers will be displayed here.</p>
  </div>
</div>
